import React, { createContext, useEffect, useState } from 'react';

export const AuthContext = createContext({});

const AuthProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [auth, setAuth] = useState();
  const [loaded, setLoaded] = useState(false);

  const authenticatedKey =
    process.env.LOCAL_STORAGE_AUTHENTICATED || 'authenticated_dev';
  const authKey = process.env.LOCAL_STORAGE_AUTH || 'auth_dev';

  const setAndSaveAuthenticated = (newValue) => {
    setAuthenticated(newValue);
    sessionStorage.setItem(authenticatedKey, newValue ? 'true' : 'false');
  };

  const setAndSaveAuth = (newValue) => {
    setAuth(newValue);
    if (newValue) {
      sessionStorage.setItem(authKey, JSON.stringify(newValue));
    } else {
      sessionStorage.removeItem(authKey);
    }
  };

  const login = (authData) => {
    setAndSaveAuthenticated(true);
    setAndSaveAuth(authData);
  };

  useEffect(() => {
    setAuthenticated(sessionStorage.getItem(authenticatedKey) === 'true');
    const savedAuth = sessionStorage.getItem(authKey);
    if (savedAuth) {
      setAuth(JSON.parse(savedAuth));
    }
    setLoaded(true);
  }, []);

  const authContext = {
    authenticated,
    auth,
    login,
    logout: () => {
      setAndSaveAuthenticated(false);
      setAndSaveAuth();
    },
  };

  if (loaded || typeof window === 'undefined') {
    return (
      <AuthContext.Provider value={authContext}>
        {children}
      </AuthContext.Provider>
    );
  }
  return <></>;
};

export default AuthProvider;
